function getDefaultRange() {
  const to = new Date();
  const from = new Date();
  from.setMonth(from.getMonth() - 6);
  return { from, to };
}

export default {
  namespaced: true,
  state: {
    initialFromDate: getDefaultRange().from,
    initialToDate: getDefaultRange().to,
  },
  actions: {
    initDefaultRange({ state, commit }) {
      // Solo inicializa si aún no hay valores
      if (!state.initialFromDate || !state.initialToDate) {
        const { from, to } = getDefaultRange();
        commit('setInitialFromDate', from);
        commit('setInitialToDate', to);
      }
    },
    setInitialFromDate({ commit }, value) {
      commit('setInitialFromDate', value);
    },
    setInitialToDate({ commit }, value) {
      commit('setInitialToDate', value);
    },
    async callStoreWithFilters({ dispatch }, params) {
      // params viene ya con yyyymmdd desde filter.js
      const { initialDateAfter, initialDateBefore } = params || {};
      return dispatch(
        'issuedInvoicesModule/fetchIssuedInvoiceList',
        {
          fechaInicio: initialDateAfter,
          fechaFin: initialDateBefore,
        },
        { root: true }
      );
    },
    clearFilters({ commit }) {
      const { from, to } = getDefaultRange();
      commit('setInitialFromDate', from);
      commit('setInitialToDate', to);
    },
  },
  mutations: {
    setInitialFromDate(state, value) {
      state.initialFromDate = value;
    },
    setInitialToDate(state, value) {
      state.initialToDate = value;
    },
    clearFilters(state) {
      const { from, to } = getDefaultRange();
      state.initialFromDate = from;
      state.initialToDate = to;
    },
  },
};
